import { useSettingsTokens } from "@/entities/settings/hooks";
import { Token } from "@/entities/settings/types";
import { Service } from "@/pages/settings/components/connectedAccounts/types";
import { getServiceConnection } from "@/pages/settings/components/connectedAccounts/serviceConnection";
import { useCanAccessAdminSettings } from "@/pages/settings/hooks";

export interface SendConnection {
  // Send waits: the connection is still loading, or the account has none
  // PandaDoc still accepts. Not held is not proof of a connection: one that
  // couldn't be read isn't held either.
  held: boolean;
  // What the rep is told: an admin connects it, or anyone else asks an admin.
  missing: "admin" | "rep" | undefined;
}

const NOT_HELD: SendConnection = { held: false, missing: undefined };

// The account's PandaDoc connection, whichever admin made it; one PandaDoc
// stopped accepting reads as missing, since it needs connecting again.
export const sendConnectionState = ({
  tokens,
  loading,
  failed,
  isAdmin
}: {
  tokens: Token[] | undefined;
  loading: boolean;
  failed: boolean;
  isAdmin: boolean;
}): SendConnection => {
  // Unread is not missing: Send goes ahead and refuses on its own if need be.
  if (failed && tokens === undefined) return NOT_HELD;
  if (getServiceConnection(tokens, Service.PANDADOC).allTokensValid) {
    return NOT_HELD;
  }
  return {
    held: true,
    missing: loading ? undefined : isAdmin ? "admin" : "rep"
  };
};

export const useSendConnection = (): SendConnection => {
  const { data, isLoading, isError } = useSettingsTokens();
  const isAdmin = useCanAccessAdminSettings();
  return sendConnectionState({
    tokens: data?.tokens,
    loading: isLoading,
    failed: isError,
    isAdmin
  });
};
